import React from "react";
import PropTypes from "prop-types";
import { Container, Row } from "shards-react";

const MainFooter = ({ contained, authors }) => (
  <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
    <Container fluid={contained}>
      <Row>
        <span className="copyright ml-auto my-auto mr-2">
          Made with <i class="fa fa-heartbeat fa-bounce"></i> By {authors}
        </span>
      </Row>
    </Container>
  </footer>
);

MainFooter.propTypes = {
  /**
   * Whether the content is contained, or not.
   */
  contained: PropTypes.bool,

  /**
   * The copyright info.
   */
  authors: PropTypes.string,
};

MainFooter.defaultProps = {
  contained: false,
  authors: `Awixor & MasterKym`,
};

export default MainFooter;
